let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gctwz")).then(() => parcelRequire('4GKfl'));